import axios from "axios";
import { generateSHA256 } from "./generateSHA256";
import { BASE_URL } from "../config";
import { UAParser } from 'ua-parser-js';
import Swal from 'sweetalert2';


export const getAuditTrailData = async(data,generateHash=true) =>{
    const parser = new UAParser();
    const result = parser.getResult();
    const os = result.os; // OS info
    const browser = result.browser; // Browser info
 
    let res = {}
    let ipData = {ip: "127.0.0.1"}
    try{
      res = await fetch("https://api.ipify.org?format=json");
    }
    catch(e){
      // Swal.fire({
      //   toast: true,
      //   title: 'Faild to fetch user IP Address, check your connection.',
      //   position: 'top-end',
      //   timer: 2500,
      //   showConfirmButton: false,
      //   icon: 'error',
      //   // didOpen: () => Swal.showLoading(),
      // });
      // return
      console.error("Failed to fetch IP:", e.message);
    }

    if(res.json){
      ipData = await res?.json();
    }

    // Exclude signature from version_content if it exists in data
    let versionContentWithoutSignature = {};
    if (data?.version_content) {
        const { signature: _, ...rest } = data.version_content;
        versionContentWithoutSignature = rest;
    }
    
    // Remove version_content from data before spreading to avoid including signature
    const { version_content: _, ...dataWithoutVersionContent } = data || {};
    
    const audit_trail_data = {
        user_ref:localStorage.getItem("user_id") || "",
        ip_address: ipData.ip || "127.0.0.1",
        device_info: `${os.name}, version ${os.version}, ${browser.name} version ${browser.version}`,
        date:new Date().toISOString(),
        signature:"",
        parent_version: null,
        version_content: versionContentWithoutSignature,
        ...dataWithoutVersionContent,
        // Override version_content to ensure signature is excluded
        version_content: {
          ...versionContentWithoutSignature,
          ...getFieldsIncluded(),
        }
    }

    const {user_ref, ip_address,device_info,date,signature,action,comment} = audit_trail_data;

    if(generateHash){
        audit_trail_data.hash = generateSHA256(user_ref+ip_address+device_info+date+signature+action+comment)
    }else{
        audit_trail_data.hash = ""
    }

    return audit_trail_data;
}


export const fileDownload = (file_name) =>{
    const link = document.createElement("a");
    link.href = BASE_URL.replace("api/", "")+`uploads/exports/${file_name}`;
    link.setAttribute("download", file_name);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export const getFieldsIncluded = () =>{
  return {
    is_signature_included: localStorage.signature_auth_methods?.includes("signature"),
    is_password_included: localStorage.signature_auth_methods?.includes("password"),
  }
}

/**
 * 
 * @param {object} exportData {apiUrl,file_name,action, additionalData};
 */
export const AuditTrailForExport = async({apiUrl,file_name,action, action_to_show, additionalData = {}}) =>{
    const ad = await getAuditTrailData({
        action,
        comment:"-",
        version_content:{file_name}
    });

    if(action_to_show)
        ad.version_content.action_to_show = action_to_show

    await axios.post(apiUrl, {
        responseType: "blob",
        file_name,
        audit_trail_data:ad,
        ...additionalData
    })
 
    fileDownload(file_name)       
}

export const GetAuditTrailForImport = async(data={}) =>{
    const ad = await getAuditTrailData({comment:"Imported via CSV",...data},false);
    return ad;
}

export function extractVersionStructure(obj) {
  if (Array.isArray(obj)) {
    return obj.map(item => extractVersionStructure(item)).filter(Boolean);
  } else if (obj && typeof obj === 'object') {
    const newObj = {};
    if (obj.version_id_ref) {
      newObj.version_id_ref = obj.version_id_ref;
    }
    
    // Preserve tree_node_id if it's a dummy ID (starts with "copy-")
    // This helps track copied sections in same-document copy operations
    if (obj.tree_node_id && obj.tree_node_id.startsWith('copy-')) {
      newObj.tree_node_id = obj.tree_node_id;
    }

    // Check nested keys that could have children
    const keys = ['steps', 'substeps', 'children'];
    keys.forEach(key => {
      if (obj[key] && Array.isArray(obj[key])) {
        const nested = extractVersionStructure(obj[key]);
        if (nested.length > 0) {
          newObj[key] = nested;
        }
      }
    });

    return Object.keys(newObj).length > 0 ? newObj : null;
  }
  return null;
}

export const prepareNewContent = ({
  allRevisionNodes,
  fromInfo,
  toInfo,
  moveType,
  node_id_key,
}) => {
  const { fromSectionId, fromStepId, fromSubstepId, nodeId } = fromInfo;
  const {
    stepId: toStepId,
    substepId: toSubstepId,
    elementId: toNodeId,
  } = toInfo;

  let newContent = structuredClone(allRevisionNodes);
  const cursection = newContent.find((s) => s.section_id_ref === fromSectionId);
  const currentStep =
    cursection?.steps.find((s) => s.step_id_ref === fromStepId) || {};
  let currentSubStep = currentStep.substeps.find(
    (s) => s.substep_id_ref === fromSubstepId
  );
  let currentElmntNode = undefined;

  const findIndex = (children) =>{
    return children.findIndex((ch) => 
      ch.detail.rich_text_node_id === toNodeId ||
      ch.detail.canvas_tree_node_id === toNodeId ||
      ch.detail.video_tree_node_id === toNodeId ||
      ch.detail.attachment_tree_node_id === toNodeId 
  );
  }

  if (currentSubStep)
    currentElmntNode = currentSubStep?.children?.find(
      (ch) => ch.detail?.[node_id_key] === nodeId
    );
  else
    currentElmntNode = currentStep?.children?.find(
      (ch) => ch.detail?.[node_id_key] === nodeId
    );

  newContent = newContent.map((section) => {
    section.steps = section.steps.map((step) => {
      if (currentSubStep) {
        step.substeps = step.substeps.map((substep) => {
          if (substep.substep_id_ref === fromSubstepId) {
            substep.children = substep.children.filter(
              (ch) => ch.detail[node_id_key] !== nodeId
            );
          }
          return substep;
        });
      } else {
        if (step.step_id_ref === fromStepId) {
          step.children = step.children.filter((ch) => {
            return ch.detail[node_id_key] !== nodeId;
          });
        }
      }
      return step;
    });
    return section;
  });
  
  if (moveType === "into") {
    newContent = newContent.map((section) => {
      section.steps = section.steps.map((step) => {
        if (step.step_id_ref === toStepId) {
          if (toSubstepId) {
            step.substeps = step.substeps.map((substep) => {
              if (substep.substep_id_ref === toSubstepId) {
                substep.children.push(currentElmntNode);
              }
              return substep;
            });
          } else {
            step.children.push(currentElmntNode);
          }
        }
        return step;
      });
      return section;
    });
  } else if (moveType === "up" || moveType === "below") {
    newContent = newContent.map((section) => {
      section.steps = section.steps.map((step) => {
        if (step.step_id_ref === toStepId) {
          if (toSubstepId) {
            step.substeps = step.substeps.map((substep) => {
              if (substep.substep_id_ref === toSubstepId) {
                const toNodeIndex = findIndex(substep.children)
                if(toNodeIndex !== -1){
                  if (toNodeIndex === 0 && moveType === "up") {
                    substep.children.unshift(currentElmntNode);
                  } else {
                    substep.children.splice(
                      moveType === "up" ? toNodeIndex : toNodeIndex + 1,
                      0,
                      currentElmntNode
                    );
                  }
                }
              }
              return substep;
            });
          } else {
            const toNodeIndex = findIndex(step.children);
            if(toNodeIndex !== -1){
              if (toNodeIndex === 0 && moveType === "up") {
                step.children.unshift(currentElmntNode);
              } else {
                step.children.splice(
                  moveType === "up" ? toNodeIndex : toNodeIndex + 1,
                  0,
                  currentElmntNode
                );
              }
            }
          }
        }
        return step;
      });
      return section;
    });
  }

  return newContent;
  // return extractVersionStructure(newContent)
};